export enum ActionType {
  Create = 'Create',
  Update = 'Update',
  Filter = 'Filter',
  Excel = 'Excel',
  Pdf = 'Pdf',
  ValidateUgovor = 'ValidateUgovor',
}



// WEBPACK FOOTER //
// ./src/app/enums/action-type.enum.ts